"use strict";

module.exports = function doesRangeSpanOrigin(range) {
  return range.start > range.end;
};